import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { VehicleContextmenuComponent } from '@app/core/components/contextmenus';
import { 
  CreateEditVehicleEntryComponent, 
  EditVehicleInventoryComponent, 
  EditVehicleInventoryCostCraneComponent, 
  DetailVehicleImagesComponent, 
  EditInvoiceComponent 
} from '@app/core/windows'; 


@Component({
  selector: 'vehicles-crud',
  templateUrl: './vehicles-crud.component.html',
  providers: [ DatasourceService ]
})
export class VehiclesCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditVehicleEntryComponent, {static: false}) window !: CreateEditVehicleEntryComponent;

  //Window - Images
  @ViewChild(DetailVehicleImagesComponent, {static: false}) win_img !: DetailVehicleImagesComponent;

  //Costo
  @ViewChild(EditVehicleInventoryCostCraneComponent, {static: false}) win_cost !: EditVehicleInventoryCostCraneComponent;

  //Liberacion
  @ViewChild(EditVehicleInventoryComponent, {static: false}) win_lib !: EditVehicleInventoryComponent;

  //Window - Invoice
  @ViewChild(EditInvoiceComponent, {static: false}) window_inv !: EditInvoiceComponent;

  //Menu
  @ViewChild(VehicleContextmenuComponent, {static: false}) menu_veh !: VehicleContextmenuComponent;

  protected menu: string = 'Movimientos';

  protected menuIcon: string = 'arrows-swap';
  
  protected label: string = 'Entrada de Vehículo';

  protected name: string = 'Vehículos';

  protected table: string = 'vehicles_inventories';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'sku_exp', dir: 'desc'}
    ];

    return s;

  }

  public onCustomExcelExport(e: any, allData: Array<any>): void {

    console.log('onCustomExcelExport');

    const rows = e.workbook.sheets[0].rows;

    let index = 0;
    rows.forEach((row) => {
      if (row.type === 'data') {+
        index++;
        row.cells.forEach((cell, i) => {
          if(typeof cell._column != 'undefined'){
            switch(cell._column){
              case 'Estatus': {
                cell.background = '#' + allData[index-1].vehicle_status_color;
                cell.color = '#ffffff';
              }; break;
            }
          }
        });
      }
    });

  }

  public onCellClick(e: any): void {
      
    console.log(e);
    if (e.type === 'contextmenu') {
      const originalEvent = e.originalEvent;
      originalEvent.preventDefault();
      // this.menu_proy.label = 'Folio consecutivo: ' + e.dataItem.folio_consecutivo;
      this.menu_veh.contextItem = e.dataItem;
      this.menu_veh.menu.show({ left: originalEvent.pageX, top: originalEvent.pageY });
    }

  }

  // public dblClickEvent(e : any) : void {

  //   // console.log('dblClickEvent', e);
  //   if (e.path[1].nodeName === 'TR') {
  //     let index = e.path[1].rowIndex;
  //     let data : DataResult = this.grid.data as DataResult;
  //     this.permissions.edit(data.data[index]);
  //   }

  // }

  public selectMenu({ menu, contextItem }): void {
    
    // console.log("selectMenu", menu, contextItem);

    if (menu.url === 'editar') {

      this.window.label = this.label;
      this.window.table = this.table;
      this.window.edit(contextItem);

    } else if (menu.url === 'eliminar') {
        
      this.removeHandler({dataItem: contextItem});

    } else if (menu.url === 'ver_fotos') {
        
      this.win_img.label = this.label;
      this.win_img.table = this.table;
      this.win_img.edit(contextItem);

    } else if (menu.url === 'editar_costo_grua') {
        
      this.win_cost.label = this.label;
      this.win_cost.table = this.table;
      this.win_cost.edit(contextItem);

    } else if (menu.url === 'eliminar_costo_grua') {
        
      this.win_cost.delete(contextItem);

    } else if (menu.url === 'liberar') {
        
      this.win_lib.label = this.label;
      this.win_lib.table = this.table;
      this.win_lib.edit(contextItem);
      
    } else if (menu.url === 'eliminar_liberacion') {
        
      this.win_lib.delete(contextItem);

    } else if (menu.url === 'factura') {
        
      this.window_inv.edit(contextItem);

    }

  }

  protected windowSaveInvoiceHandler({mode, dataItem}) {

    let msg = this.window_inv.getObjectString(dataItem)
    this.alertService.showUpdateSuccess(msg);
    this.service.pagination(this.table, this.state);

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}